import { render } from "./RequestUpdateModal.vue?vue&type=template&id=581b16f2"
import script from "./RequestUpdateModal.vue?vue&type=script&lang=js"
export * from "./RequestUpdateModal.vue?vue&type=script&lang=js"

import "./RequestUpdateModal.vue?vue&type=style&index=0&id=581b16f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__